enum ProjectTypes {
  TimeBank = "TIME_BANK",
  Incident = "INCIDENT",
  Corrective = "CORRECTIVE",
  Allocation = "ALLOCATION",
  Factory = "FACTORY",
  Internal = "INTERNAL",
}

export default ProjectTypes;
